module.exports = __webpack_public_path__ + "img/program-icon_6.2e91bd6d.png";